import React from "react";

export default function UserUser() {
    return (
        <div className="bg-black p-6 flex flex-wrap justify-center gap-8 min-h-screen">
            <div className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md">
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[12px] leading-[15px] text-[#6B7280] mt-1">
                            posted on June 13, 2024
                        </p>
                    </div>
                    <button
                        aria-label="Diamond icon"
                        className="bg-[#0B84FF] rounded-r-md rounded-l-md px-3 py-2"
                    >
                        <i className="fas fa-gem text-white text-lg"></i>
                    </button>
                </div>
                <div className="bg-[#F3E8FF] text-[#A78BFA] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#EDE9FE]">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Waiting for Funding
                </div>
                <div className="p-5 pt-4 border-b border-[#E5E7EB] grid grid-cols-3 text-center text-[13px] leading-[16px] font-normal text-[#6B7280]">
                    <div>
                        <p>Asking</p>
                        <p className="mt-1 text-[18px] font-normal text-[#0B1033]">$100</p>
                    </div>
                    <div className="flex items-center justify-center space-x-1 text-[#6B7280]">
                        <span>→</span>
                    </div>
                    <div>
                        <p>Payback</p>
                        <p className="mt-1 text-[16px] font-normal text-[#166534]">$120</p>
                    </div>
                    <div></div>
                    <div>
                        <p>Due on</p>
                        <p className="mt-1 text-[16px] font-normal text-[#B91C1C]">June 30</p>
                    </div>
                    <div></div>
                </div>
                <button
                    className="bg-[#FF0000] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full"
                    type="button"
                >
                    Delete Loan
                </button>
            </div>
            <div
                className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md"
            >
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[12px] leading-[15px] text-[#6B7280] mt-1">
                            posted on June 13, 2024
                        </p>
                    </div>
                    <button
                        aria-label="Diamond icon"
                        className="bg-[#0B84FF] rounded-r-md rounded-l-md px-3 py-2"
                    >
                        <i className="fas fa-gem text-white text-lg"></i>
                    </button>
                </div>
                <div
                    className="bg-[#FEE2E2] text-[#EF4444] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#FECACA]"
                >
                    <i className="fas fa-exclamation-circle mr-1"></i> 5 Days Left
                </div>
                <div className="p-5 pt-4 border-b border-[#E5E7EB] grid grid-cols-3 text-center text-[13px] leading-[16px] font-normal text-[#6B7280]">
                    <div>
                        <p>Remaining Balance</p>
                        <p className="mt-1 text-[16px] font-extrabold text-[#B91C1C]">$100</p>
                    </div>
                    <div></div>
                    <div>
                        <p>Due on</p>
                        <p className="mt-1 text-[16px] font-normal text-[#B91C1C]">June 30</p>
                    </div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full"
                    type="button"
                >
                    Repay Loan
                </button>
            </div>
            <div
                className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md"
            >
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[12px] leading-[15px] text-[#6B7280] mt-1">
                            posted on June 13, 2024
                        </p>
                    </div>
                    <button
                        aria-label="Delete icon"
                        className="bg-[#D1D5DB] rounded-md px-3 py-2 cursor-default"
                        disabled
                    >
                        <i className="fas fa-trash-alt text-white text-lg"></i>
                    </button>
                </div>
                <div
                    className="bg-[#FEE2E2] text-[#EF4444] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#FECACA]"
                >
                    <i className="fas fa-exclamation-circle mr-1"></i> 5 Days Left
                </div>
                <div className="p-5 pt-4 border-b border-[#E5E7EB] grid grid-cols-3 text-center text-[13px] leading-[16px] font-normal text-[#6B7280]">
                    <div>
                        <p>Asking</p>
                        <p className="mt-1 text-[18px] font-normal text-[#0B1033]">$100</p>
                    </div>
                    <div className="flex items-center justify-center space-x-1 text-[#6B7280]">
                        <span>→</span>
                    </div>
                    <div>
                        <p>Payback</p>
                        <p className="mt-1 text-[16px] font-normal text-[#166534]">$120</p>
                    </div>
                    <div></div>
                    <div>
                        <p>Due on</p>
                        <p className="mt-1 text-[16px] font-normal text-[#B91C1C]">June 30</p>
                    </div>
                    <div></div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full"
                    type="button"
                >
                    Repay Loan
                </button>
            </div>
            <div
                className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md"
            >
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[12px] leading-[15px] text-[#6B7280] mt-1">
                            posted on June 13, 2024
                        </p>
                    </div>
                    <button
                        aria-label="Delete icon"
                        className="bg-[#D1D5DB] rounded-md px-3 py-2 cursor-default"
                        disabled
                    >
                        <i className="fas fa-trash-alt text-white text-lg"></i>
                    </button>
                </div>
                <div
                    className="bg-[#FEF3C7] text-[#D97706] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#FDE68A]"
                >
                    <i className="fas fa-exclamation-circle mr-1"></i> 1 Week Left
                </div>
                <div className="p-5 pt-4 border-b border-[#E5E7EB] grid grid-cols-3 text-center text-[13px] leading-[16px] font-normal text-[#6B7280]">
                    <div>
                        <p>Remaining Balance</p>
                        <p className="mt-1 text-[16px] font-extrabold text-[#B91C1C]">$100</p>
                    </div>
                    <div></div>
                    <div>
                        <p>Due on</p>
                        <p className="mt-1 text-[16px] font-normal text-[#B45309]">June 30</p>
                    </div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full"
                    type="button"
                >
                    Repay Loan
                </button>
            </div>
            <div
                className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md"
            >
                <div className="p-5 pb-3">
                    <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                        Unexpected car repair,<br />waiting for reimbursement
                    </h3>
                    <p className="text-[13px] leading-[16px] text-[#6B7280] mt-2">
                        You Funded <span className="font-extrabold">$2300</span> to <em><a href="#" className="text-[#2563EB] underline">StudentNurse25</a></em>
                    </p>
                </div>
                <div
                    className="bg-[#DBEAFE] text-[#2563EB] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#BFDBFE]"
                >
                    <i className="fas fa-info-circle mr-1"></i>
                    Due on <strong>June 30</strong> (5 Days Left)
                </div>
                <div className="p-5 pt-4">
                    <p className="text-[13px] leading-[16px] font-normal text-[#6B7280] mb-1">
                        Repayment Progress
                    </p>
                    <p className="text-[36px] font-extrabold text-[#2563EB] leading-[44px]">
                        $2190<span className="text-[#6B7280] font-normal text-[24px]">/$2500</span>
                    </p>
                    <p className="text-[12px] leading-[15px] font-semibold text-[#6B7280] mt-1">
                        <span className="font-extrabold">$310.00</span> Remaining for Complete Payback
                    </p>
                    <div className="w-full h-4 rounded-full bg-[#D9D9D9] mt-3 overflow-hidden">
                        <div className="h-4 rounded-l-full bg-gradient-to-r from-[#86EFAC] to-[#4ADE80]" style={{width: "87.6%"}}></div>
                    </div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full flex items-center justify-center gap-2"
                    type="button"
                >
                    Borrow Insight
                    <i className="fas fa-external-link-alt text-white text-sm"></i>
                </button>
            </div>
            <div
                className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md"
            >
                <div className="p-5 pb-3 flex justify-between items-start">
                    <div>
                        <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                            Unexpected car repair,<br />waiting for reimbursement
                        </h3>
                        <p className="text-[12px] leading-[15px] text-[#6B7280] mt-1">
                            posted on June 13, 2024
                        </p>
                    </div>
                    <button
                        aria-label="Delete icon"
                        className="bg-[#D1D5DB] rounded-md px-3 py-2 cursor-default"
                        disabled
                    >
                        <i className="fas fa-trash-alt text-white text-lg"></i>
                    </button>
                </div>
                <div
                    className="bg-[#D1FAE5] text-[#22C55E] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#A7F3D0]"
                >
                    <i className="fas fa-check-circle mr-1"></i> 1 Month Left
                </div>
                <div className="p-5 pt-4 border-b border-[#E5E7EB] grid grid-cols-3 text-center text-[13px] leading-[16px] font-normal text-[#6B7280]">
                    <div>
                        <p>Remaining Balance</p>
                        <p className="mt-1 text-[16px] font-extrabold text-[#B91C1C]">$100</p>
                    </div>
                    <div></div>
                    <div>
                        <p>Due on</p>
                        <p className="mt-1 text-[16px] font-normal text-[#15803D]">June 30</p>
                    </div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full"
                    type="button"
                >
                    Repay Loan
                </button>
            </div>
            <div
                className="bg-white rounded-xl max-w-[320px] w-full h-full flex flex-col shadow-md"
            >
                <div className="p-5 pb-3">
                    <h3 className="font-extrabold text-[15px] leading-[18px] text-[#0B1033]">
                        Unexpected car repair,<br />waiting for reimbursement
                    </h3>
                    <p className="text-[13px] leading-[16px] text-[#6B7280] mt-2">
                        by <em><a href="#" className="text-[#2563EB] underline">StudentNurse25</a></em>
                    </p>
                </div>
                <div
                    className="bg-[#DBEAFE] text-[#2563EB] text-center text-[14px] leading-[18px] font-normal py-2 border-t border-b border-[#BFDBFE]"
                >
                    <i className="fas fa-info-circle mr-1"></i>
                    Due on <strong>June 30</strong> (5 Days Left)
                </div>
                <div className="p-5 pt-4">
                    <div className="grid grid-cols-2 text-[13px] leading-[16px] font-normal text-[#6B7280]">
                        <div>
                            <p>Funded</p>
                            <p className="mt-1 text-[16px] font-extrabold text-[#0B1033]">$90</p>
                        </div>
                        <div>
                            <p className="flex justify-between mb-1">
                                <span>Repayment Progress</span>
                            </p>
                            <span className="text-[#15803D] font-extrabold">$100</span>
                            <span> of </span>
                            <span className="text-[#2563EB] font-extrabold">$120</span>
                            <span> Received</span>
                            <div className="w-full h-4 rounded-full bg-[#D9D9D9] mt-1 overflow-hidden">
                                <div className="h-4 rounded-l-full bg-[#15803D]" style={{width: "83.33%"}}></div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    className="bg-[#2563EB] text-white font-extrabold text-[14px] leading-[18px] py-3 rounded-b-xl w-full flex items-center justify-center gap-2"
                    type="button"
                >
                    Borrow Insight
                    <i className="fas fa-external-link-alt text-white text-sm"></i>
                </button>
            </div>
        </div>
    );
}
